import { useTranslation } from "react-i18next";

const Title = ({ mode }: { mode: string }) => {
  const { t } = useTranslation();

  const titleColor = mode === "light" ? "text-sangati-green" : "text-white";

  return (
    <>
      <div
        className={`text-7xl font-bold ${titleColor} text-center`}
      >
        <h1>Sa&#x0307;nga&#x0307;ti</h1>
      </div>
      <div className={`font-bold ${titleColor} text-4xl text-center mt-3`}>
        <p>{t(`${mode}ChoiceTitle`)}</p>
      </div>
    </>
  );
};

export default Title;
